module.exports = __webpack_public_path__ + "static/img/3.6de8990.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/eng/3.png
// module id = tlok
// module chunks = 0